// @ts-nocheck
/**
 * ツインキーシステム - 定数定義
 * @module twinKey/data/constants
 */

// ============================================================
// レアリティ設定
// ============================================================

export const RARITY_CONFIG = {
  C:   { initialMultiplier: 1.00, maxLevel: 10,  maxLevelMultiplier: 1.5 },
  UC:  { initialMultiplier: 1.05, maxLevel: 20,  maxLevelMultiplier: 2.0 },
  R:   { initialMultiplier: 1.10, maxLevel: 40,  maxLevelMultiplier: 3.0 },
  SR:  { initialMultiplier: 1.15, maxLevel: 60,  maxLevelMultiplier: 4.0 },
  UR:  { initialMultiplier: 1.20, maxLevel: 100, maxLevelMultiplier: 6.0 },
  HR:  { initialMultiplier: 1.25, maxLevel: 120, maxLevelMultiplier: 7.5 },
  SEC: { initialMultiplier: 1.25, maxLevel: 120, maxLevelMultiplier: 7.5 },
  ALT: { initialMultiplier: 1.25, maxLevel: 120, maxLevelMultiplier: 7.5 },
  SP:  { initialMultiplier: 1.30, maxLevel: 150, maxLevelMultiplier: 9.0 },
  GR:  { initialMultiplier: 1.50, maxLevel: 150, maxLevelMultiplier: 9.0 },
};

// レアリティ値（ダンジョン深さ計算用）
// 設計書 v0.4: 基礎階層 = 10 + (レアリティ合計 - 2) × 5
// 範囲: C+C=2 → 10F, GR+GR=20 → 100F (特別: 110F)
export const RARITY_VALUES = {
  C: 1, UC: 2, R: 3, SR: 4, UR: 5,
  HR: 6, SEC: 7, ALT: 8, SP: 9, GR: 10,
};

// ============================================================
// スキル設定
// ============================================================

// スキルクールダウン
export const SKILL_COOLDOWNS = {
  skill_1: 2,
  skill_2: 3,
  skill_3: 5,
};

// スキル倍率
export const SKILL_MULTIPLIERS = {
  skill_1: { single: 1.2, aoe: 0.5 },
  skill_2: { single: 1.5, aoe: 0.75 },
  skill_3: { single: 2.0, aoe: 1.0 },
};

// スキル解放レベル
export const SKILL_UNLOCK_LEVELS = {
  skill_1: 20,
  skill_2: 40,
  skill_3: 60,
};

// スキル3の開始時クールダウン
export const SKILL_3_INITIAL_CD = 3;

// ============================================================
// 属性設定
// ============================================================

// 属性相性（攻撃側 → 有利な防御側）
// 三すくみ1: 炎 → 原始 → 水 → 炎
// 三すくみ2: 光 → 闇 → 未来 → 光
export const ATTRIBUTE_ADVANTAGE = {
  '炎': '原始',
  '原始': '水',
  '水': '炎',
  '光': '闇',    // 光が闇を払う
  '闇': '未来',  // 闇が未来を蝕む
  '未来': '光',  // 未来が光（現秩序）を覆す
};

// 対立軸（相互に攻撃側有利）
// 原始 ↔ 未来: 時空の対立
export const ATTRIBUTE_RIVALRY = {
  '原始': '未来',
  '未来': '原始',
};

// 属性相性倍率
export const ATTRIBUTE_MULTIPLIERS = {
  effective: 1.5,       // 三すくみ有利
  rivalry: 1.25,        // 対立（攻撃側有利）
  neutral: 1.0,         // 等倍
  not_effective: 0.67,  // 三すくみ不利
};

// 属性スコア（大陸決定用）
export const ATTRIBUTE_SCORES = {
  '炎':   { heat: 10, darkness: 0,  future: 0  },
  '水':   { heat: -5, darkness: 3,  future: 0  },
  '光':   { heat: 5,  darkness: -10, future: 0  },
  '闇':   { heat: 0,  darkness: 10, future: 0  },
  '未来': { heat: 0,  darkness: 0,  future: 10 },
  '原始': { heat: 8,  darkness: 5,  future: -10 },
  'なし': { heat: 0,  darkness: 0,  future: 0  },
};

// ============================================================
// 覚醒設定
// ============================================================

export const AWAKENING_BONUS = {
  0: 0.00,
  1: 0.05,
  2: 0.10,
  3: 0.15,
  4: 0.20,
  5: 0.30,
};

export const MAX_AWAKENING = 5;

// ============================================================
// バトル設定
// ============================================================

// クリティカル
export const CRITICAL = {
  rate: 0.10,
  multiplier: 1.5,
};

// 防御最低保証
export const MIN_DAMAGE_REDUCTION = 0.15;

// パーティサイズ
export const PARTY_SIZE = 5;

// ============================================================
// ダンジョン設定
// ============================================================

// フロアタイプ
export const FLOOR_TYPES = {
  battle: { name: '戦闘', icon: '⚔️' },
  strong_enemy: { name: '強敵', icon: '💀' },
  treasure: { name: '宝箱', icon: '📦' },
  event: { name: 'イベント', icon: '❓' },
  trap: { name: '罠', icon: '⚠️' },
  rest: { name: '休憩', icon: '🏕️' },
  boss: { name: 'ボス', icon: '👹' },
};

// ボス階層間隔
export const BOSS_FLOOR_INTERVAL = 10;

// 休憩時HP回復率
export const REST_HP_RECOVERY = 0.30;

// 強敵報酬倍率
export const STRONG_ENEMY_REWARD_MULTIPLIER = 2.0;

// ============================================================
// ギミック定義
// ============================================================

export const GIMMICKS = [
  { id: 'poison_swamp', name: '毒沼', effect: '毎階層HP-5%', hpLossPerFloor: 0.05 },
  { id: 'lava', name: '溶岩', effect: '毎階層HP-3%', hpLossPerFloor: 0.03 },
  { id: 'fog', name: '霧', effect: '命中率-20%', accuracyMod: -0.20 },
  { id: 'ash_storm', name: '灰の嵐', effect: '回避-10%', evasionMod: -0.10 },
  { id: 'miasma', name: '呪瘴', effect: '毎ターンHP-2%', hpLossPerTurn: 0.02 },
  { id: 'none', name: 'なし', effect: '特殊効果なし' },
];

// ============================================================
// 報酬設定
// ============================================================

// 難易度別基礎報酬
export const DIFFICULTY_REWARDS = {
  '初級': { goldBase: 3000, goldMax: 5000, expMultiplier: 1.0 },
  '中級': { goldBase: 10000, goldMax: 20000, expMultiplier: 1.5 },
  '上級': { goldBase: 30000, goldMax: 60000, expMultiplier: 2.0 },
  '超級': { goldBase: 100000, goldMax: 300000, expMultiplier: 3.0 },
};

// 評価ボーナス
export const RATING_BONUS = {
  3: 2.0,  // ☆☆☆ ノーダメージ
  2: 1.5,  // ☆☆ 被ダメージ30%以下
  1: 1.0,  // ☆ クリア
};

// ============================================================
// 経験値テーブル
// ============================================================

// レベルアップに必要な経験値
export function getRequiredExp(level) {
  // 基本式: 100 * level^1.5
  return Math.floor(100 * Math.pow(level, 1.5));
}

// 敵撃破時の獲得経験値
// 仕様: 獲得EXP = 基礎EXP(300) × Lv補正(√(敵Lv/10)) × 敵種類補正
// 敵種類補正: 通常1.0, 強敵2.0, ボス5.0
export function getEnemyExp(enemyLevel, enemyType = 'normal') {
  const BASE_EXP = 300;
  const levelMultiplier = Math.sqrt(enemyLevel / 10);

  let typeMultiplier = 1.0;
  if (enemyType === 'strong') {
    typeMultiplier = 2.0;
  } else if (enemyType === 'boss') {
    typeMultiplier = 5.0;
  }

  return Math.floor(BASE_EXP * levelMultiplier * typeMultiplier);
}

// 戦闘全体の獲得経験値を計算
export function calculateBattleExp(enemies, battleType) {
  if (!enemies || enemies.length === 0) return 0;

  // battleType: 'battle' | 'strong_enemy' | 'boss'
  const isBoss = battleType === 'boss';
  const isStrong = battleType === 'strong_enemy';

  // 全敵のレベルの平均を取る
  const avgLevel = enemies.reduce((sum, e) => sum + (e.level || 1), 0) / enemies.length;

  // 敵種類補正を決定
  let enemyType = 'normal';
  if (isBoss) {
    enemyType = 'boss';
  } else if (isStrong) {
    enemyType = 'strong';
  }

  // 基本経験値
  const baseExp = getEnemyExp(avgLevel, enemyType);

  // 敵の数によるボーナス（複数敵の場合は少し多め）
  const countBonus = 1 + (enemies.length - 1) * 0.3;

  return Math.floor(baseExp * countBonus);
}

// ============================================================
// アイテム設定（Phase 1 簡易版）
// ============================================================

export const ITEMS = {
  hp_potion: {
    id: 'hp_potion',
    name: 'HPポーション',
    effect: 'HP30%回復',
    trigger: 'hp_below_30',
    healPercent: 0.30,
  },
  revive: {
    id: 'revive',
    name: '蘇生薬',
    effect: '戦闘不能回復（HP50%）',
    trigger: 'ally_defeated',
    reviveHpPercent: 0.50,
  },
  antidote: {
    id: 'antidote',
    name: '万能薬',
    effect: '状態異常回復',
    trigger: 'status_effect',
  },
};

// 持ち込み枠数
export const ITEM_SLOTS = 3;
// 各枠の個数
export const ITEMS_PER_SLOT = 3;
